<template>
    <v-container fluid grid-list-md>
        <v-card class="mb-5">
            <v-toolbar dark color="primary">
                <v-toolbar-title>NHVAS Reporting</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-row align="center">
                    <v-col cols="auto">
                        <v-btn-toggle v-model="periodType" mandatory dense>
                            <v-btn value="quarterly" small>Quarterly</v-btn>
                            <v-btn value="yearly" small>Yearly</v-btn>
                        </v-btn-toggle>
                    </v-col>
                    <v-col cols="3">
                        <v-select
                            v-model="selectedFinancialYear"
                            :items="financialYears"
                            item-text="label"
                            item-value="value"
                            label="Financial Year"
                            hide-details
                        ></v-select>
                    </v-col>
                    <v-col cols="3" v-if="periodType === 'quarterly'">
                        <v-select
                            v-model="selectedQuarter"
                            :items="quarters"
                            item-text="label"
                            item-value="value"
                            label="Quarter"
                            hide-details
                        ></v-select>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                            color="primary"
                            @click="generateReport"
                            :loading="$wait.is('loading nhvas report')"
                        >Generate</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card v-if="report">
            <v-toolbar dark color="primary">
                <v-toolbar-title>NHVAS Reporting</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs4>
                            <v-chip small color="gray">{{ report.periodLabel }}</v-chip>
                        </v-flex>
                        <v-flex xs6>Total NHVAS Units</v-flex>
                        <v-flex xs2>{{ report.totalNhvasUnits }}</v-flex>
                        <v-flex xs4></v-flex>
                        <v-flex xs6>PM Services Completed</v-flex>
                        <v-flex xs2>{{ report.totalPms }}</v-flex>
                        <v-flex xs4></v-flex>
                        <v-flex xs6>PM Services Completed Outside Tolerance</v-flex>
                        <v-flex xs2>{{ report.pmServicesCompletedOutsideTolerance }}</v-flex>

                        <v-flex xs4 class="mt-5">
                            <v-chip small color="green" class="white--text">Current Period</v-chip>
                        </v-flex>
                        <v-flex xs6 class="mt-5">(A) Defects received</v-flex>
                        <v-flex xs2 class="mt-5">{{ report.currentPeriodDefectsReceived }}</v-flex>
                        <v-flex xs4></v-flex>
                        <v-flex xs6>(B) Defects Closed</v-flex>
                        <v-flex xs2>{{ report.currentPeriodDefectsClosed }}</v-flex>

                        <v-flex xs4 class="mt-5">
                            <v-chip small color="red lighten-4">Previous Period(s)</v-chip>
                        </v-flex>
                        <v-flex xs6 class="mt-5">(C) Defects Carried Forward</v-flex>
                        <v-flex xs2 class="mt-5">{{ report.previousPeriodDefectsCarriedForward }}</v-flex>
                        <v-flex xs4></v-flex>
                        <v-flex xs6>(D) Defects Closed from Previous</v-flex>
                        <v-flex xs2>{{ report.previousPeriodDefectsClosedFromPrevious }}</v-flex>
                        <v-flex xs4></v-flex>
                        <v-flex xs6>(E) Defects NOT Closed from Previous</v-flex>
                        <v-flex xs2>{{ report.previousPeriodDefectsNotClosedFromPrevious }}</v-flex>

                        <v-flex xs4 class="mt-5">
                            <v-chip small color="red" class="white--text">Future Outstanding</v-chip>
                        </v-flex>
                        <v-flex xs6 class="mt-5">(F) Defects Carried Forward</v-flex>
                        <v-flex xs2 class="mt-5">{{ report.futureOutstandingDefectsCarriedForward }}</v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="report = null">Start Over</v-btn>
                <v-btn
                    color="primary"
                    @click="downloadPdf"
                    :loading="$wait.is('downloading nhvas pdf')"
                >
                    <v-icon left>save_alt</v-icon>
                    Download PDF
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>
<script>
import DownloadHelper from '@/lib/DownloadHelper';

export default {
    data() {
        return {
            periodType: 'quarterly',
            selectedFinancialYear: null,
            selectedQuarter: null,
            report: null
        };
    },
    computed: {
        financialYears() {
            var now = new Date();
            var currentFY = now.getMonth() >= 6 ? now.getFullYear() + 1 : now.getFullYear();
            return [
                { label: `FY ${currentFY - 1}-${currentFY}`, value: currentFY },
                { label: `FY ${currentFY - 2}-${currentFY - 1}`, value: currentFY - 1 },
                { label: `FY ${currentFY - 3}-${currentFY - 2}`, value: currentFY - 2 }
            ];
        },
        quarters() {
            return [
                { label: 'Q1 (Jul - Sep)', value: 1 },
                { label: 'Q2 (Oct - Dec)', value: 2 },
                { label: 'Q3 (Jan - Mar)', value: 3 },
                { label: 'Q4 (Apr - Jun)', value: 4 }
            ];
        }
    },
    mounted() {
        var now = new Date();
        this.selectedFinancialYear = now.getMonth() >= 6 ? now.getFullYear() + 1 : now.getFullYear();
        this.selectedQuarter = this.getMostRecentCompletedQuarter();
    },
    methods: {
        getMostRecentCompletedQuarter() {
            var month = new Date().getMonth(); // 0-indexed
            // Return the most recently completed quarter
            // Q1: Jul(6)-Sep(8), Q2: Oct(9)-Dec(11), Q3: Jan(0)-Mar(2), Q4: Apr(3)-Jun(5)
            if (month >= 0 && month <= 2) return 2;   // In Jan-Mar, last completed is Q2
            if (month >= 3 && month <= 5) return 3;   // In Apr-Jun, last completed is Q3
            if (month >= 6 && month <= 8) return 4;   // In Jul-Sep, last completed is Q4
            return 1;                                   // In Oct-Dec, last completed is Q1
        },
        async generateReport() {
            try {
                this.$wait.start('loading nhvas report');
                var url = `defects/nhvas-report?financialYear=${this.selectedFinancialYear}`;
                if (this.periodType === 'quarterly') {
                    url += `&quarter=${this.selectedQuarter}`;
                }
                var response = await this.$api.get(url);
                this.report = response.data;
            } catch (err) {
                this.$toast.error('There was an error getting NHVAS Report data');
            } finally {
                this.$wait.end('loading nhvas report');
            }
        },
        async downloadPdf() {
            try {
                this.$wait.start('downloading nhvas pdf');
                var url = `defects/nhvas-report/pdf?financialYear=${this.selectedFinancialYear}`;
                if (this.periodType === 'quarterly') {
                    url += `&quarter=${this.selectedQuarter}`;
                }
                var response = await this.$api.get(url, { responseType: 'blob' });
                var periodSuffix = this.periodType === 'quarterly'
                    ? `Q${this.selectedQuarter}`
                    : 'FullYear';
                var filename = `nhvas_report_FY${this.selectedFinancialYear}_${periodSuffix}.pdf`;
                DownloadHelper.download(filename, new Blob([response.data], { type: 'application/pdf' }));
            } catch (err) {
                this.$toast.error('There was an error downloading the NHVAS Report PDF');
            } finally {
                this.$wait.end('downloading nhvas pdf');
            }
        }
    }
};
</script>
